import React from "react";
import { Dialog, DialogActions, Typography, Button, Box, useMediaQuery, useTheme, CircularProgress, } from "@mui/material";
import { Icon } from "@iconify/react";
import { between } from "../style/style";
import { FIconButton } from "../buttons/IButton";
const FDialog = ({ isOpen, onClose, onSubmit, loading = false, title, children, confirmText = "Confirm", cancelText = "Cancel", maxWidth = "md", disableActions = false, fullHeight = false, actions, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const ActionButtons = () => {
        if (disableActions)
            return null;
        if (actions)
            return React.createElement(DialogActions, { sx: { p: 3 } }, actions);
        return (React.createElement(DialogActions, { sx: { p: 3, pt: 2 } },
            React.createElement(Button, { onClick: onClose, color: "inherit", variant: "outlined", disabled: loading, fullWidth: isMobile }, cancelText),
            React.createElement(Button, { onClick: onSubmit, variant: "contained", color: "primary", sx: { color: "white" }, type: "submit", disabled: loading, fullWidth: isMobile, startIcon: loading ? React.createElement(CircularProgress, { size: 16, color: "inherit" }) : null }, confirmText)));
    };
    const Header = () => (React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { padding: "24px 16px", pt: isMobile ? 2 : 3, pb: 0 }) },
        React.createElement(Typography, { variant: "h6" }, title),
        React.createElement(FIconButton, { onClick: onClose, title: "Close" },
            React.createElement(Icon, { icon: "mingcute:close-line", width: "18", height: "18" }))));
    // Always use Drawer, anchor depends on screen size
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: maxWidth, fullWidth: true, PaperProps: {
            sx: {
                borderTopLeftRadius: isMobile ? 12 : 0,
                borderTopRightRadius: isMobile ? 12 : 0,
                // borderBottomLeftRadius: !isMobile ? 12 : 0,
                // borderBottomRightRadius: !isMobile ? 12 : 0,
                maxHeight: isMobile ? "95dvh" : "100dvh",
                minHeight: isMobile ? undefined : "320px",
                // margin: isMobile ? 0 : "0 auto",
                display: "flex",
                flexDirection: "column",
            },
        } },
        Header(),
        React.createElement(Box, { sx: { p: 2, overflowY: "auto", flex: 1 } }, children),
        ActionButtons()));
};
export default FDialog;
